//
import axios from "axios"

//
export default class Service {

    /**
     * return a axios instance for service
     */
    get $http () {
        return axios.create({
            baseURL: this.fullURL(),
        })
    }
    
    /**
     * define a base url for a REST API
     */
    baseURL () {
        return String( process.env.VUE_APP_API_ROUTE )
    }

    /**
     * return the full url resource for this service
     */
    fullURL () {
        return String( this.fullURLParams().join( "/" ) )
    }

    /**
     * return the full url params resource for this service
     */
    fullURLParams () {
        return [ this.baseURL(), this.resource() ]
    }

    /**
     * return the resource url for this service
     */
    resource () {
        return String( "" )
    }
}